var map = {
	"./5_rabbit.mp3": "67f95",
	"./6_bear.mp3": "c8a1",
	"./7_mole.mp3": "4bf3",
	"./M_Brilliant.mp3": "f771",
	"./M_Excellent.mp3": "040a",
	"./M_Fantastic.mp3": "4ff5",
	"./M_Great.mp3": "9e90",
	"./M_Perfect.mp3": "525a",
	"./M_Think again.mp3": "2ac4",
	"./M_Try again.mp3": "94a2",
	"./M_Very good.mp3": "48b6",
	"./M_Well done.mp3": "565d",
	"./M_Work harder.mp3": "c48a",
	"./click.mp3": "d37b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bee";